module.exports = __webpack_public_path__ + "static/_bcitLogo-b2bff1f20affd4ac538df008720af137.png";